<template>
    <DropFile class="drop-area" v-bind="$attrs" @file="$emit('file', $event)">
        <template #default="{ selectFile }">
            <IconDownload class="icon" />

            <div class="title">
                <slot :selectFile="selectFile" name="title">
                    <span>Переместите сюда файл(ы) или</span>
                    <button class="no-border accent" @click="selectFile">выберите на
                        компьютере
                    </button>
                </slot>
            </div>

            <div class="description">
                <slot name="description" />
            </div>
        </template>
    </DropFile>
</template>

<script>
import DropFile from '@dsee/components/attachment/DropFile.vue';
import IconDownload from './icons/download.svg?component';


export default {
    name: 'DropArea',
    components: {
        DropFile,
        IconDownload,
    },
    data() {
        return {};
    },
    computed: {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.drop-area {
    background: rgba(249, 249, 251, 1);
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    padding: 12px;

    .icon {
        color: var(--theme-main-color);
    }

    .title {
        margin-bottom: 4px;
        font-weight: 500;
    }

    .description {
        color: var(--input-placeholder-color);
        font-size: 12px;
        line-height: 16px;
    }
}
</style>
